module.exports = __webpack_public_path__ + "img/icon_kj.8bbee499.png";